import { APIConstraintEnforcementMode } from '@ardoq/api-types';
import { isArdoqError } from '@ardoq/common-helpers';
import { map, Observable } from 'rxjs';
import { currentOrganization$ } from './organizations/currentOrganization$';

export const constraintsEnforcementMode$: Observable<APIConstraintEnforcementMode> =
  currentOrganization$.pipe(
    map(org => {
      if (isArdoqError(org)) {
        return 'off';
      }
      return org.settings.constraintEnforcementMode ?? 'off';
    })
  );
